<script setup lang="ts">
  import { MenuItem } from '@headlessui/vue'
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    icon?: string,
    to?: RouteLocationRaw,
    href?: string,
  }>()

  defineOptions({
    inheritAttrs: false,
  })
</script>

<template>
  <menu-item v-slot="{ close, disabled, active }">
    <router-link
      v-if="to && !disabled"
      v-slot="{ href: hr }"
      :to="to"
      custom>
      <a
        :href="hr"
        v-bind="$attrs"
        class="dropdown-item"
        :class="{
          '!cursor-not-allowed !text-gray-400 hover:!bg-gray-100': disabled,
          'bg-primary text-white': active,
        }"
        @click="close()">
        <fa-icon
          v-if="icon"
          class="mr-3"
          :icon="icon"
          fixed-width />
        <slot></slot>
      </a>
    </router-link>
    <component
      :is="href ? 'a' : 'button'"
      v-bind="$attrs"
      v-else
      class="dropdown-item"
      :class="{
        disabled: disabled,
        active: active,
      }"
      :target="href ? '_blank' : undefined"
      :href="href"
      :type="href ? undefined : 'button'">
      <fa-icon
        v-if="icon"
        class="mr-3"
        :icon="icon"
        fixed-width />
      <slot></slot>
    </component>
  </menu-item>
</template>

<style lang="postcss" scoped>
  .dropdown-item {
    @apply w-full flex cursor-pointer items-center whitespace-nowrap px-4 py-2 first:pt-4 last:pb-4 text-sm text-left;

    &:hover,
    &.active {
      @apply bg-primary-100;
    }

    &.disabled {
      @apply !cursor-not-allowed !text-gray-400 hover:!bg-gray-100;
    }
  }
</style>
